import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["button", "input", "status"]
  static values = { copied: String, error: String, text: String }

  async copy() {
    const text = this.hasTextValue ? this.textValue : (this.inputTarget.value ?? this.inputTarget.textContent)
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        const input = document.createElement("textarea")
        input.value = text
        input.style.position = "fixed"
        input.style.opacity = "0"
        document.body.append(input)
        const focused = document.activeElement
        input.select()
        let copied
        try { copied = document.execCommand("copy") } finally { input.remove(); focused?.focus() }
        if (!copied) throw new Error("Clipboard unavailable")
      }
      this.feedback(this.copiedValue || "Copied!")
    } catch (_) {
      this.feedback(this.errorValue || "Could not copy. Select and copy the text manually.")
    }
  }

  feedback(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
    if (!this.hasButtonTarget) return
    clearTimeout(this.timer)
    this.originalLabel ??= this.buttonTarget.innerHTML
    this.buttonTarget.textContent = message
    this.timer = setTimeout(() => { this.buttonTarget.innerHTML = this.originalLabel }, 2000)
  }

  disconnect() {
    clearTimeout(this.timer)
    if (this.originalLabel && this.hasButtonTarget) this.buttonTarget.innerHTML = this.originalLabel
  }
}
